<template>
	<div class="space">
		<div class="base-search">
			<el-button type="success" icon="el-icon-plus" @click="addEvent" style="background: #623AA2; border: none;">新增</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
			<el-input placeholder="请输入内容" v-model="searchValue" class="input-with-select" @keyup.enter.native="search" clearable
			 @clear="search" style="width:240px">
				<el-button slot="append" icon="el-icon-search" @click="search"></el-button>
			</el-input>
			<label>众创空间类型:</label>
			<el-select style="width:140px" v-model="fieldValue" clearable placeholder="全部" @change="search">
				<el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<label>服务方式:</label>
			<el-select style="width:140px" v-model="levelValue" clearable placeholder="全部" @change="search">
				<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<label>服务对象:</label>
			<el-select style="width:140px" v-model="targetValue" clearable placeholder="全部" @change="search">
				<el-option v-for="item in fieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
		</div>
		<div class="base-table">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
			 class="table" @selection-change="selectionChange">
				<el-table-column type="selection" width="55"></el-table-column>

				<el-table-column type="index" width="150" label="序号" align="center">
					<template slot-scope="scope">
						<span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="名称" align="center" prop="name"></el-table-column>
				<el-table-column label="简介" align="center">
					<template slot-scope="scope">
						<span style="display:block;height:23px;overflow: hidden;">{{GetTarg(scope.row.introduction)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="日期" align="center" prop="dateTime"></el-table-column>
				<el-table-column label="是否推荐" align="center" prop="hot">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.hot == 1" type="success" effect="plain">是</el-tag>
						<el-tag v-else type="danger" effect="plain">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column width="240px" align="center" label="操作">
					<template slot-scope="scope">
						<!-- <el-button
              size="mini"
              type="success"
              @click="release(scope.row, 1)"
              v-if="scope.row.hot == 2"
            >推荐资源</el-button>
            <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button>-->
						<el-button class="mini_btn" size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button class="mini_btn" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination @current-change="handleCurrentChange" :current-page.sync="current_page" :page-size="per_page" layout="total,prev, pager, next"
		 :total="total" style="text-align:left;margin:20px 0"></el-pagination>
		<el-dialog @closed="is_submit = true" :title="Title" center :visible.sync="dialogFormVisible" :close-on-click-modal="false"
		 :append-to-body="true">
			<el-form v-if="dialogFormVisible" :model="ruleForm" ref="ruleForm" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-row>
							<el-form-item label="众创空间名称" prop="name">
								<el-input v-model="ruleForm.name" placeholder="请输入众创空间名称"></el-input>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="众创空间类型" prop="field">
								<el-select multiple style="width:100%" v-model="ruleForm.field" placeholder="请选择">
									<el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="服务方式" prop="level">
								<el-select multiple style="width:100%" v-model="ruleForm.level" placeholder="请选择">
									<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-row>
						<el-row>
							<el-form-item label="服务对象" prop="target">
								<el-select multiple style="width:100%" v-model="ruleForm.target" placeholder="请选择">
									<el-option v-for="item in fieldOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-row>
					</el-col>
					<el-col :span="12">
						<el-form-item label="logo" prop="logo">
							<el-upload class="avatar-uploader" :action="this.uploadURL" name="file" :show-file-list="false" :on-success="handlePictureCardPreview"
							 :before-upload="beforeAvatarUpload" :http-request="HouImgFile">
								<img v-if="ruleForm.logo" :src="imgUrl+ruleForm.logo" class="img_border" v-real-img="ruleForm.logo" />
								<i v-else class="el-icon-plus avatar-uploader-icon" :class="{is_border: !ruleForm.logo}"></i>
								<span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
								<span v-else class="upload_btn">更换图片</span>
							</el-upload>
							<span class="del_img" v-show="ruleForm.logo">
								<i class="el-icon-error" @click="deleteImg"></i>
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-form-item label="通讯地址" prop="detailed">
						<v-distpicker style="text-align:left;" @selected="citySelected" :province="ruleForm.address.province.value" :city="ruleForm.address.city.value"
						 :area="ruleForm.address.area.value"></v-distpicker>
						<el-input style="margin-top:10px" v-model="ruleForm.detailed" placeholder="请填写详细地址"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="实景图" style="text-align:center">
						<el-upload style="text-align:left" :action="this.uploadURL" list-type="picture-card" :file-list="fileList"
						 :on-preview="pictureCardPreview1" :before-upload="beforeUpload1" :on-remove="handleRemove1" :http-request="HouImgFile1">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="可自主支配的孵化场地总面积(平方米)" class="special" prop="a005">
							<el-input v-model.number="ruleForm.a005" placeholder="请填写可自主支配的孵化场地总面积"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="在孵企业场地面积(平方米)" class="special" prop="a006">
							<el-input v-model.number="ruleForm.a006" placeholder="请填写在孵企业场地面积"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="公共服务场地面积 (平方米)" class="special" prop="a007">
							<el-input v-model.number="ruleForm.a007" placeholder="请填写公共服务场地面积 "></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="自用面积(平方米)" class="special" prop="a008">
							<el-input v-model.number="ruleForm.a008" placeholder="请填写自用面积"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="其他面积(平方米)" class="special" prop="a009">
							<el-input v-model.number="ruleForm.a009" placeholder="请填写其他面积"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="在孵企业使用面积(含公共服务面积)占总面积比例" class="special" prop="a010">
							<el-input v-model.number="ruleForm.a010" placeholder="请填写在孵企业使用面积（含公共服务面积）占总面积比例 "></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="可自主支配场地内在孵企业数量(家)" class="special" prop="a011">
							<el-input v-model.number="ruleForm.a011" placeholder="请填写可自主支配场地内在孵企业数量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="在孵企业总数量(家)" class="special" prop="a012">
							<el-input v-model.number="ruleForm.a012" placeholder="请填写在孵企业总数量"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="已申请专利的在孵企业占比" class="special" prop="a013">
							<el-input v-model.number="ruleForm.a013" placeholder="请填写已申请专利的在孵企业占比"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="年均毕业企业数占在孵企业总数的比例" class="special" prop="a014">
							<el-input v-model.number="ruleForm.a014" placeholder="请填写年均毕业企业数占在孵企业总数的比例"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="累计毕业企业数量(家)" class="special" prop="a015">
							<el-input v-model.number="ruleForm.a015" placeholder="请填写累计毕业企业数量"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="孵化器管理机构人员总数" class="special" prop="a016">
							<el-input v-model.number="ruleForm.a016" placeholder="请填写孵化器管理机构人员总数"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="专业孵化服务人员数量" class="special" prop="a017">
							<el-input v-model.number="ruleForm.a017" placeholder="请填写专业孵化服务人员数量"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="专业孵化服务人员占机构总人数的比例" class="special" prop="a018">
							<el-input v-model.number="ruleForm.a018" placeholder="请填写专业孵化服务人员占机构总人数的比例"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="创业导师数量" prop="a019">
							<el-input v-model.number="ruleForm.a019" placeholder="请填写创业导师数量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="带动就业人数" prop="a027">
							<el-input v-model.number="ruleForm.a027" placeholder="请填写带动就业人数"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="已申请专利的在孵企业数量(家)" class="special" prop="a020">
							<el-input v-model.number="ruleForm.a020" placeholder="请填写已申请专利的在孵企业数量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="占在孵企业总数比例(%)" class="special" prop="a021">
							<el-input v-model.number="ruleForm.a021" placeholder="请填写占在孵企业总数比例"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="拥有有效知识产权的在孵企业数量(家)" class="special" prop="a022">
							<el-input v-model.number="ruleForm.a022" placeholder="请填写拥有有效知识产权的在孵企业数量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="占在孵企业总数比例(%)" class="special" prop="a023">
							<el-input v-model.number="ruleForm.a023" placeholder="请填写占在孵企业总数比例"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col>
						<el-form-item label="每千平方米在孵企业数量(家)" class="special" prop="a024">
							<el-input v-model.number="ruleForm.a024" placeholder="请填写每千平方米在孵企业数量"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="在同一产业领域从事研发、生产的在孵企业数量(家)" class="special" prop="a025">
							<el-input v-model.number="ruleForm.a025" placeholder="请填写在同一产业领域从事研发、生产的在孵企业数量"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="占在孵企业总数比例(%)" class="special" prop="a026">
							<el-input v-model.number="ruleForm.a026" placeholder="请填写占在孵企业总数比例"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-form-item label="众创空间简介" prop="introduction">
						<editor refName="introduction" :placeholderText="'请填写众创空间简介,比如场地面积，人员团队，导师，入驻条件等'" v-model="ruleForm.introduction"
						 :upload-url="uploadURL" :img-show-url="imgUrl"></editor>
						<!-- <editor
            refName='introduction'
            :placeholder="'请填写众创空间简介,比如场地面积，人员团队，导师，入驻条件等'"
            :quill-data="ruleForm.introduction"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            @getQuillData="getQuillData"
            ></editor>-->
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="服务介绍与收费标准" prop="standard">
						<editor refName="standard" :placeholderText="'请填写服务介绍与收费标准'" v-model="ruleForm.standard" :upload-url="uploadURL"
						 :img-show-url="imgUrl"></editor>
						<!-- <editor
            refName='standard'
            :placeholder="'请填写服务介绍与收费标准'"
            :quill-data="ruleForm.standard"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            @getQuillData="getQuillData1"
            ></editor>-->
					</el-form-item>
				</el-row>
				<el-row>
					<el-col :span="5">
						<el-form-item style="text-align:left" label="是否推荐" prop="hot">
							<el-switch v-model="ruleForm.hot" :active-value="1" :inactive-value="2" active-color="#13ce66" inactive-color="#ff4949"
							 active-text="是" inactive-text="否"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="推荐度" prop="hotOrder">
							<!-- <el-input v-model.number="ruleForm.hotOrder" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
							<el-slider v-model="ruleForm.hotOrder" show-input :disabled="ruleForm.hot == 2"></el-slider>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeForm('ruleForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
			<img width="100%" :src="dialogImageUrl" alt />
		</el-dialog>
	</div>
</template>

<script type="text/ecmascript-6">
	// import editor from "../../../components/yhQuillEditor";
	import editor from "../../../components/tinymce-editor/tinymce-editor";
	export default {
		components: {
			editor,
		},
		data() {
			var validateHoto = (rule, value, callback) => {
				if (this.ruleForm.hot == 1) {
					if (!value) {
						callback(new Error("请设置推荐度"));
					}
					if (!Number.isInteger(value)) {
						callback(new Error("请输入数字值"));
					} else {
						callback();
					}
				} else {
					callback();
				}
			};
			return {
				is_submit: true,
				levelValue: "",
				fieldValue: "",
				targetValue: "",
				total: 10,
				per_page: 10,
				current_page: 1,
				Title: "",
				searchValue: "",
				dialogFormVisible: false,
				dialogVisible: false,
				dialogImageUrl: "",
				deleteRow: "",
				fileList: [],
				tableData: [],
				fieldOptions: [{
						value: "001",
						label: "微型企业",
					},
					{
						value: "002",
						label: "小型企业",
					},
					{
						value: "003",
						label: "中型企业",
					},
					{
						value: "004",
						label: "大型企业",
					},
					{
						value: "005",
						label: "创业个人或团队",
					},
					{
						value: "006",
						label: "个体工商户",
					},
					{
						value: "007",
						label: "事业单位社会团体",
					},
					{
						value: "008",
						label: "其他",
					},
				],
				levelOptions: [{
						value: "001",
						label: "投资促进型",
					},
					{
						value: "002",
						label: "培训辅导型",
					},
					{
						value: "003",
						label: "媒体延伸型",
					},
					{
						value: "004",
						label: "专业服务型",
					},
					{
						value: "005",
						label: "创客孵化型",
					},
				],
				typeOptions: [{
						value: "001",
						label: "柜台式服务",
					},
					{
						value: "002",
						label: "电话服务",
					},
					{
						value: "003",
						label: "上门服务",
					},
					{
						value: "004",
						label: "刊物",
					},
					{
						value: "005",
						label: "信函服务",
					},
					{
						value: "006",
						label: "网络服务",
					},
					{
						value: "007",
						label: "合同式服务",
					},
					{
						value: "008",
						label: "其他",
					},
				],
				ruleForm: {
					name: "",
					logo: "",
					image: "",
					address: {
						province: {
							value: "甘肃省",
						},
						city: {
							value: "兰州市",
						},
						area: {
							value: "城关区",
						},
					},
					detailed: "",
					field: [],
					level: [],
					target: [],
					introduction: "",
					standard: "",
					hot: 2,
					hotOrder: 0,
					a005: "",
					a006: "",
					a007: "",
					a008: "",
					a009: "",
					a010: "",
					a011: "",
					a012: "",
					a013: "",
					a014: "",
					a015: "",
					a016: "",
					a017: "",
					a018: "",
					a019: "",
					a020: "",
					a021: "",
					a022: "",
					a023: "",
					a024: "",
					a025: "",
					a026: "",
					a027: "",
				},
				rules: {
					name: [{
						required: true,
						message: "请输入众创空间名称",
						trigger: "blur"
					}, ],
					detailed: [{
						validator: (rule, value, callback) =>
							this.CheckAddress(rule, value, callback, this.ruleForm),
						required: true,
						trigger: "blur",
					}, ],
					field: [{
						required: true,
						message: "请选择众创空间类型",
						trigger: "change"
					}, ],
					level: [{
						required: true,
						message: "请选择服务方式",
						trigger: "change"
					}, ],
					target: [{
						required: true,
						message: "请选择服务对象",
						trigger: "change"
					}, ],
					logo: [{
						required: true,
						message: "请上传logo",
						trigger: "blur"
					}],
					introduction: [{
						required: true,
						message: "请输入众创空间简介",
						trigger: "blur"
					}, ],

					standard: [{
						required: true,
						message: "请输入服务介绍与收费标准",
						trigger: "blur",
					}, ],
					hotOrder: [{
						required: true,
						validator: validateHoto,
						trigger: "blur"
					}, ],
					a001: [{
						required: true,
						message: "请选择注册时间",
						trigger: "change"
					}, ],
					a002: [{
						required: true,
						message: "请选择运营时间",
						trigger: "change"
					}, ],
					a005: [{
						required: true,
						message: "请填写可自主支配的孵化场地总面积",
						trigger: "blur",
					}, ],
					a006: [{
						required: true,
						message: "请填写在孵企业场地面积",
						trigger: "blur",
					}, ],
					a007: [{
						required: true,
						message: "请填写公共服务场地面积",
						trigger: "blur",
					}, ],
					a008: [{
						required: true,
						message: "请填写自用面积",
						trigger: "blur"
					}],
					a009: [{
						required: true,
						message: "请填写其他面积",
						trigger: "blur"
					}],
					a010: [{
						required: true,
						message: "请填写在孵企业使用面积(含公共服务面积)占总面积比例",
						trigger: "blur",
					}, ],
					a011: [{
						required: true,
						message: "请填写可自主支配场地内在孵企业数量",
						trigger: "blur",
					}, ],
					a012: [{
						required: true,
						message: "请填写在孵企业总数量",
						trigger: "blur"
					}, ],
					a013: [{
						required: true,
						message: "请填写已申请专利的在孵企业占比",
						trigger: "blur",
					}, ],
					a014: [{
						required: true,
						message: "请填写年均毕业企业数占在孵企业总数的比例",
						trigger: "blur",
					}, ],
					a015: [{
						required: true,
						message: "请填写累计毕业企业数量",
						trigger: "blur",
					}, ],
					a016: [{
						required: true,
						message: "请填写孵化器管理机构人员总数",
						trigger: "blur",
					}, ],
					a017: [{
						required: true,
						message: "请填写专业孵化服务人员数量",
						trigger: "blur",
					}, ],
					a018: [{
						required: true,
						message: "请填写专业孵化服务人员占机构总人数的比例",
						trigger: "blur",
					}, ],
					a019: [{
						required: true,
						message: "请填写创业导师数量",
						trigger: "blur"
					}, ],
					a020: [{
						required: true,
						message: "请填写已申请专利的在孵企业数量",
						trigger: "blur",
					}, ],
					a021: [{
						required: true,
						message: "请填写占在孵企业总数比例",
						trigger: "blur",
					}, ],
					a022: [{
						required: true,
						message: "请填写拥有有效知识产权的在孵企业数量",
						trigger: "blur",
					}, ],
					a023: [{
						required: true,
						message: "请填写占在孵企业总数比例",
						trigger: "blur",
					}, ],
					a024: [{
						required: true,
						message: "请填写每千平方米在孵企业数量",
						trigger: "blur",
					}, ],
					a025: [{
						required: true,
						message: "请填写在孵企业数量",
						trigger: "blur"
					}, ],
					a026: [{
						required: true,
						message: "请填写占在孵企业总数比例",
						trigger: "blur",
					}, ],
				},
			};
		},
		created() {
			this.getData("Resource_Space?all=1&page=" + this.current_page);
		},
		methods: {
			// release(row,type){
			//   let obj = {};
			//   obj.id = row.id;
			//   obj.type = 14;
			//   obj.hot = 1;
			// },
			getData(url) {
        let params = {};
        if(url.indexOf('?') > -1){
          let urlParams = url.split('?')[1]?.split('&')
          urlParams.forEach(item => {
            params[item.split('=')[0]] = item.split('=')[1]
          })
        }

        this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-space/page`, params).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.total;
						this.per_page = res.data.per_page;
						this.current_page = res.data.current_page * 1;
					}
				});
			},
			//城市选择
			citySelected(e) {
				this.ruleForm.address = e;
			},
			//富文本
			getQuillData(val) {
				this.ruleForm.introduction = val;
			},
			getQuillData1(val) {
				this.ruleForm.standard = val;
			},
			//新增
			addEvent() {
				if (this.$refs["ruleForm"]) {
					this.$refs["ruleForm"].resetFields();
				}
				this.dialogFormVisible = true;
				this.Title = "新增";
				this.fileList = [];
				this.ruleForm = {
					name: "",
					logo: "",
					image: "",
					address: {
						province: {
							value: "甘肃省",
						},
						city: {
							value: "兰州市",
						},
						area: {
							value: "城关区",
						},
					},
					detailed: "",
					field: [],
					level: [],
					target: [],
					introduction: "",
					standard: "",
					hot: 2,
					hotOrder: 0,
					a005: "",
					a006: "",
					a007: "",
					a008: "",
					a009: "",
					a010: "",
					a011: "",
					a012: "",
					a013: "",
					a014: "",
					a015: "",
					a016: "",
					a017: "",
					a018: "",
					a019: "",
					a020: "",
					a021: "",
					a022: "",
					a023: "",
					a024: "",
					a025: "",
					a026: "",
					a027: "",
				};
			},
			//批量删除
			deleteAll() {
				if (this.deleteRow) {
					this.$confirm("此操作将批量删除, 是否继续?", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
							center: true,
						})
						.then(() => {
							this.http
								.request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-space/batchDelete?ids=` + this.deleteRow, "", "delete")
								.then((res) => {
									if (res.code == 0) {
										this.getData("Resource_Space?all=1&page=1");
										this.$message({
											type: "success",
											message: "删除成功",
										});
										this.ResetSearch(['searchValue', 'targetValue', 'fieldValue', 'levelValue'])

									} else {
										this.$message({
											message: "失败！",
											type: "error",
										});
									}
								});
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消删除",
							});
						});
				} else {
					this.$message({
						type: "warning",
						message: "请选择删除的记录",
					});
				}
			},
			//搜索
			search() {
				this.getData(
					"Resource_Space?all=1&name=" +
					this.searchValue +
					"&page=" +
					this.current_page +
					(this.levelValue ? "&level=" + this.levelValue : "") +
					(this.fieldValue ? "&field=" + this.fieldValue : "") +
					(this.targetValue ? "&target=" + this.targetValue : "")
				);
			},
			//选择
			selectionChange(selection) {
				this.deleteRow = "";
				if (selection.length != 0) {
					let arr = [];
					selection.forEach((item) => {
						arr.push(item.id);
					});
					this.deleteRow = arr.join(",");
				}
			},
			//编辑
			handleEdit(index, row) {
				this.dialogFormVisible = true;
				this.Title = "编辑";
				row.detailed = row.address ? row.address.detailed : "";
				row.address = row.address ?
					row.address :
					{
						province: {
							value: ""
						},
						city: {
							value: ""
						},
						area: {
							value: ""
						}
					};
				this.ruleForm = JSON.parse(JSON.stringify(row));
				this.fileList = [];
				this.ruleForm.field = row.field?row.field.split(","):[];
				this.ruleForm.level = row.level?row.level.split(","):[];
				this.ruleForm.target = row.target?row.target.split(","):[];
				// this.ruleForm.detailed = row.address.detailed;
				if (row.image) {
					let arr = [];
					arr = row.image.split(",");
					arr.forEach((item, index) => {
						this.fileList.push({
							name: "download.jpg",
							url: this.imgUrl + item,
							store_result: item,
							uid: new Date().getTime() + index,
						});
					});
				}
			},
			//删除
			handleDelete(index, row) {
				this.$confirm("此操作将永久删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http
							.request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-space/delete?id=` + row.id, "", "delete")
							.then((res) => {
								if (res.code == 0) {
									this.getData("Resource_Space?all=1&page=" + this.current_page);
									this.$message({
										type: "success",
										message: "删除成功",
									});
									this.ResetSearch(['searchValue', 'targetValue', 'fieldValue', 'levelValue'])

								} else {
									this.$message({
										message: "失败！",
										type: "error",
									});
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//翻页
			handleCurrentChange(e) {
				this.getData(
					"Resource_Space?all=1&name=" +
					this.searchValue +
					"&page=" +
					e +
					(this.levelValue ? "&level=" + this.levelValue : "") +
					(this.fieldValue ? "&field=" + this.fieldValue : "") +
					(this.targetValue ? "&target=" + this.targetValue : "")
				);
			},
			//取消
			closeForm(name) {
				this.dialogFormVisible = false;
				this.$refs[name].resetFields();
			},
			//获取经纬度
			factory(name) {
				this.$jsonp(
						"https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
						this.ruleForm.detailed +
						"&city=" +
						this.ruleForm.address.city.value +
						"&children=1&offset=20&page=1&extensions=all"
					)
					.then((json) => {
						let arr = json.pois[0].location.split(",");
						this.ruleForm.longitude = arr[0];
						this.ruleForm.latitude = arr[1];
						this.subData(name);
					})
					.catch((err) => {
						this.$message.error("未获取到经纬度,请查看地址是否完整");
					});
			},
			subData(name) {
				console.log("简要", this.is_submit);
				if (!this.is_submit) {
					return;
				}
				this.is_submit = false;
				let obj = JSON.parse(JSON.stringify(this.ruleForm));
				let arr = [];
				this.fileList.forEach((item) => {
					if (item.response) {
						arr.push(item.response.data.store_result);
					} else {
						arr.push(item.store_result);
					}
				});
				obj.image = arr.join(",");
				obj.address.detailed = this.ruleForm.detailed;
				obj.field = this.ruleForm.field.join(",");
				obj.level = this.ruleForm.level.join(",");
				obj.target = this.ruleForm.target.join(",");
				obj.dateTime = new Date().format("yyyy-MM-dd hh:mm:ss");
				let area = [{
						name: "兰州市",
						id: "001",
					},
					{
						name: "嘉峪关市",
						id: "002",
					},
					{
						name: "金昌市",
						id: "003",
					},
					{
						name: "白银市",
						id: "004",
					},
					{
						name: "天水市",
						id: "005",
					},
					{
						name: "武威市",
						id: "006",
					},
					{
						name: "张掖市",
						id: "007",
					},
					{
						name: "酒泉市",
						id: "008",
					},
					{
						name: "平凉市",
						id: "009",
					},
					{
						name: "庆阳市",
						id: "010",
					},
					{
						name: "定西市",
						id: "011",
					},
					{
						name: "陇南市",
						id: "012",
					},
					{
						name: "临夏回族自治州",
						id: "013",
					},
					{
						name: "甘南藏族自治州",
						id: "014",
					},
				];
				area.forEach((item) => {
					if (obj.address.city.value == item.name) {
						obj.area = item.id;
					}
				});
				if (obj.hot == 2) {
					obj.hotOrder = 0;
				}
				delete obj.detailed;
				if (!this.ruleForm.id) {
					this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-space/create`, obj).then((res) => {
						if (res.code == 0) {
							this.getData("Resource_Space?all=1&page=1");
							this.$message({
								type: "success",
								message: "新增成功",
							});
							this.ResetSearch(['searchValue', 'targetValue', 'fieldValue', 'levelValue'])

							this.dialogFormVisible = false;
							this.$refs[name].resetFields();
						} else {
							this.is_submit = true;
						}
					}).catch(err => {
						this.is_submit = true;
					});
				}
				if (this.Title == "编辑") {
					// delete obj.id;
					this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-space/update` , obj).then((res) => {
						if (res.code == 0) {
							this.getData("Resource_Space?all=1&page=1");
							this.$message({
								type: "success",
								message: "编辑成功",
							});
							this.dialogFormVisible = false;
							this.ResetSearch(['searchValue', 'targetValue', 'fieldValue', 'levelValue'])

							this.$refs[name].resetFields();
						} else {
							this.is_submit = true;
						}
					}).catch(err => {
						this.is_submit = true;
					});
				}
			},
			//提交
			submitForm(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.factory(name);
					} else {
						return false;
					}
				});
			},
			//上传图片
			HouImgFile(e) {
				var files = e.file;
				if (!files) return;
				this.createImage(files, e, "HouImg");
			},
			//其他图片上传
			createImage(file, e, Name) {
				//lrz压缩
				// lrz图片先压缩在加载、
				lrz(file, {
						width: 960,
					})
					.then((rst) => {
						this.http
							.post("/file/base64_upload", {
								image: rst.base64,
							})
							.then((res) => {
								this.ruleForm.logo = res.data;
							});
						return rst;
					})
					.always(() => {
						// 清空文件上传控件的值
						e.target.value = null;
					});
			},
			handlePictureCardPreview(file) {
				this.ruleForm.logo = file.data.store_result;
			},
			beforeAvatarUpload(file) {
				let type = false;
				if (
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpg" ||
					file.type === "image/gif" ||
					file.type === "image/bmp"
				) {
					type = true;
				}

				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!type) {
					this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 10MB!");
				}
				return type && isLt2M;
			},
			deleteImg() {
				this.$confirm("确定删除图片吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.ruleForm.logo = "";
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//上传照片墙
			HouImgFile1(e) {
				var files = e.file;
				if (!files) return;
				this.createImage1(files, e, "HouImg");
			},
			//其他图片上传
			createImage1(file, e, Name) {
				//lrz压缩
				// lrz图片先压缩在加载、
				lrz(file, {
						width: 960,
					})
					.then((rst) => {
						this.http
							.post("/file/base64_upload", {
								image: rst.base64,
							})
							.then((res) => {
								this.fileList.push({
									name: file.name,
									url: this.imgUrl + res.data,
									store_result: res.data,
									uid: file.uid,
								});
							});
						return rst;
					})
					.always(() => {
						// 清空文件上传控件的值
						e.target.value = null;
					});
			},
			//移除
			handleRemove1(file, fileList) {
				this.fileList = fileList;
			},
			//上传前
			beforeUpload1(file) {
				let type = false;
				if (
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpg" ||
					file.type === "image/gif" ||
					file.type === "image/bmp"
				) {
					type = true;
				}

				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!type) {
					this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 10MB!");
				}
				return type && isLt2M;
			},
			//查看
			pictureCardPreview1(file, fileList) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
		},
	};
</script>

<style scoped lang="scss">
	.space {
		height: 100%;
		width: 100%;

		.base-search {
			width: 100%;
			text-align: left;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.el-select {
				margin: 0 15px;
			}

			/deep/.el-input--suffix {
				width: 100%;
			}

			.el-input {
				margin: 0 15px;
			}

			.date-picker {
				margin: 0 15px;

				.el-range-separator {
					width: auto;
				}
			}
		}

		.base-table {
			width: 100%;
			margin-top: 20px;
			border: 1px solid #eef1f6;
		}
	}

	/*上传图片*/
	.is_border {
		border: 1px dashed #ddd !important;
		border-radius: 5px;
		height: 154px !important;
		line-height: 154px !important;
	}

	.upload_btn {
		display: block;
		background-color: #00a1ff;
		font-weight: bold;
		color: #fff;
		padding: 2px;
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.upload_btn:hover {
		background-color: #13ce66;
	}

	.del_img {
		position: absolute;
		top: -7px;
		left: 224px;
		color: #00a1ff;
	}

	.del_img:hover {
		cursor: pointer;
		color: #f00;
	}

	.del_img i:before {
		font-size: 20px;
	}

	.img_border {
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
		width: 243px;
		height: 154px;
		display: block;
	}

	.avatar-uploader {
		text-align: center;
		width: 243px;
		height: 198px;
	}

	/deep/ .el-upload {
		border: 1px dashed #d9d9d9 !important;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	/deep/ .el-upload:hover {
		border-color: #409eff !important;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 243px;
		height: 154px;
		line-height: 154px;
		text-align: center;
	}
</style>
